import { render, staticRenderFns } from "./CardArticles.vue?vue&type=template&id=3eeeebef"
import script from "./CardArticles.vue?vue&type=script&lang=js"
export * from "./CardArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports